/**
 * This filter can be used in any ng-repeat to trim array to a specific range.
 * The first parameter defines the start point, the second parameter defines the end point.
 * If the end point is bigger than length of the array it will iterate to the end of the array and not further.
 *
 * usage: "item in data : range: 3:12"
 *
 * this iterates over the elements 3 till 12.
 */
angular.module('impactx.displayelements').filter('range', function() {
    return function(input, start, end) {
        var result = [];
        if(input) {
            start = parseInt(start);
            end = parseInt(end);
            end >= input.length ? end = input.length-1 : end;

            for(var i = start; i <= end; i++) {
                result.push(input[i]);
            }
        }

        return result;
    };
});